import { VideoJsPlayer } from "video.js";
import { IMedia } from "models/media.model";

export function getCurrentVideo(player: VideoJsPlayer, media: IMedia[]): IMedia {
    // playlist
    if (media.length > 1) {
        // const playlist = player.playlist() || null;
        return media[0]
    } else {
        return media[0];
    }
}
